import { useState, FormEvent } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { supabase } from '@/lib/supabase'
import { Button } from '@/components/ui/Button'
import { Mail, Lock, Loader2 } from 'lucide-react'

type LocationState = { from?: string } | null

export function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()
  const location = useLocation()
  const from = (location.state as LocationState)?.from ?? '/dashboard'

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError(null)
    const { error: err } = await supabase.auth.signInWithPassword({ email, password })
    setLoading(false)
    if (err) {
      setError(err.message)
      return
    }
    navigate(from, { replace: true })
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="inline-flex w-14 h-14 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl items-center justify-center shadow-lg shadow-amber-500/20 mb-3">
            <span className="font-display text-2xl font-semibold text-white">S</span>
          </div>
          <h1 className="font-display text-4xl font-semibold text-navy-700">SimpliaCollect</h1>
          <p className="text-slate-500 text-sm mt-1">Iniciá sesión para continuar</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white border border-slate-200 rounded-2xl p-8 shadow-card space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1.5 block">Email</label>
            <div className="relative">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                placeholder="tu@email.com"
                className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-lg text-sm focus:border-amber-500 focus:outline-none"
              />
            </div>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1.5 block">Contraseña</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="w-full pl-9 pr-3 py-2.5 border border-slate-300 rounded-lg text-sm focus:border-amber-500 focus:outline-none"
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg p-3">
              {error}
            </div>
          )}

          <Button type="submit" variant="amber" size="lg" className="w-full" disabled={loading}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Entrar'}
          </Button>

          <div className="text-center">
            <a href="#" className="text-xs text-slate-500 hover:text-amber-600">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
        </form>

        <div className="text-center text-xs text-slate-400 mt-6">
          Simplia Consulting · Almacenes Point · v0.1
        </div>
      </div>
    </div>
  )
}
